var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container"},[_c('el-tooltip',{attrs:{"content":_vm.text,"placement":"top","disabled":_vm.tooltip,"popper-class":_vm.area ? 'textarea-tooltip' : ''}},[_c('div',{ref:"tooltip-overflow",staticClass:"overflow",style:(_vm.lineClampStyle)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }